module.exports = __webpack_public_path__ + "img/9791185035369.4281ed5c.jpg";